import styled from "@emotion/styled";
import { useFormContext } from "react-hook-form";
import BasicButton from "@components/button/BasicButton";
import { FormTitle } from "@pages/join/_components/index";
import { Nickname } from "./Nickname";
import { Birthday } from "./Birthday";
import { Gender } from "./Gender";
import { Address } from "./Address";
import { Country } from "./Country";
import { Name } from "./Name";

interface SignupFormProps {
  onSubmit?: () => void;
}

export default function SignupForm({ onSubmit }: SignupFormProps) {
  const {
    watch,
    formState: { isValid },
  } = useFormContext();

  const isFormValid = isValid && watch("isNicknameUnique") === true;

  return (
    <>
      <FormTitle>{"기본정보를 작성해주세요."}</FormTitle>
      <Container onSubmit={onSubmit} noValidate>
        {/* 이름 입력 필드 */}
        <Name />
        {/* 닉네임 입력 필드 */}
        <Nickname />
        {/* 생년월일 선택 필드 */}
        <Birthday />
        {/* 성별 선택 필드 */}
        <Gender />
        {/* 국가 선택 필드 */}
        <Country />
        {/* 주소 선택 필드  */}
        <Address />
        <BasicButton
          title="다음"
          height="5.2rem"
          width="100%"
          padding="1.6rem 1.2rem"
          type="submit"
          disabled={!isFormValid}
        />
      </Container>
    </>
  );
}

const Container = styled.form({
  display: "flex",
  flexDirection: "column",
  gap: "4rem",
  paddingBottom: "2rem",
});
